import * as types from './actionTypes';
import axios from 'axios';
import { setGlobalErrors } from './globalErrorActions';
import { getHeader, getMessageByErrorStatus } from '../helper';

function receiveTransaction(data) {
    return {
        type: types.LOAD_TRANSACTION_SUCCESS,
        data: data
    }
}

function requestTransaction(params) {
    return {
        type: types.LOAD_TRANSACTION_REQUEST,
        params
    }
}

function transactionError(messages) {
    return {
        type: types.LOAD_TRANSACTION_FAILURE,
        messages
    }
}

export function getTransaction(params = {}) {
    
    return function (dispatch) {
        dispatch(requestTransaction(params));
        dispatch(setGlobalErrors('transaction', {}));

        return axios.get(`${window.siteUrl}/api/v1/money_flow/`, {
            params: params,
            headers: getHeader()
        })
        .then(function (response) {
            dispatch(receiveTransaction(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("load transaction error-", err.data, err.status, err.headers);
                dispatch(transactionError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('transaction', {status: err.status, error: errorText}));
            }
        });
    }
}


function receiveMoreTransaction(data) {
    return {
        type: types.LOAD_MORE_TRANSACTION_SUCCESS,
        data: data
    }
}

function requestMoreTransaction() {
    return {
        type: types.LOAD_MORE_TRANSACTION_REQUEST
    }
}

function moreTransactionError(messages) {
    return {
        type: types.LOAD_MORE_TRANSACTION_FAILURE,
        messages
    }
}

export function getMoreTransaction(nextPage, args) {
    let defaultSettings = {
        params: {},
        headers: getHeader()
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,//eto prinsipe ne nujno
            ...args.params
        }
    });

    return function (dispatch) {
        dispatch(requestMoreTransaction());
        dispatch(setGlobalErrors('transaction', {}));

        return axios.get(nextPage, {
            params: newSettings.params,
            headers: newSettings.headers
        })
        .then(function (response) {
            dispatch(receiveMoreTransaction(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("more transaction creator error-", err.data, err.status, err.headers);
                dispatch(moreTransactionError(err.data));

                let errorText = getMessageByErrorStatus(err.status);
                dispatch(setGlobalErrors('transaction', {status: err.status, error: errorText}));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/transactionActions.js